import { Stack } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  totalSteps: number;
  activeStep: number;
}

/**
 * Der Fortschritt des Assistenten als Balken statt als Punkte.
 *
 * Punkte sagten nur „einer von vier ist der aktuelle"; der Balken zeigt auch, wie viel
 * schon hinter dem Kunden liegt — deshalb ist alles bis einschließlich des aktuellen
 * Schrittes gefüllt.
 */
const StepProgress: React.FC<Props> = ({ totalSteps, activeStep }) => {
  const { classes, cx } = useStyles();

  return (
    <Stack className={classes.stepProgress} direction={'row'} gap={0.75}>
      {Array.from({ length: totalSteps }, (_item, index) => index).map((item) => (
        <div key={item} className={cx(classes.segment, item <= activeStep ? 'done' : null)} />
      ))}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  stepProgress: {
    width: '100%',
  },
  segment: {
    flex: 1,
    height: '5px',
    borderRadius: '3px',
    background: theme.palette.greys.lighter,
    transition: '225ms',
    '&.done': {
      background: theme.palette.primary.main,
    },
  },
}));

export default StepProgress;
